import './Switch.css';

const Switch = function Switch({ label = '', checked, onChange }) {
    return (
        <div className='flex switch-container'>
            <label className="switch">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                />
                <div className="slider round"></div>
            </label>
            <span>
                {label.split(" OR ").map((part, i) => (
                    <span key={i}>
                        {part}
                        {i !== label.split(" OR ").length - 1 && <span className='font-bold'> OR </span>}
                    </span>
                ))}
            </span>
        </div>
    );
};

export default Switch;
